import React from 'react';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    dataAttributes?: {
        [key: string]: string;
    };
}

const Link: React.FC<LinkProps> = ({ dataAttributes, children, ...props }) => {
    const dataProps = dataAttributes
        ? Object.keys(dataAttributes).reduce(
              (result, key) => {
                  result[`data-${key}`] = dataAttributes[key];
                  return result;
              },
              {} as { [key: string]: string }
          )
        : {};

    return (
        <a {...props} {...dataProps}>
            {children}
        </a>
    );
};

export default Link;
